/***
 * Created on 2023/8/31
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import {apiGet} from "../service/api";


export function usePreCheckPassword() {
    const checkPassword = async ({onSuccess, onError}) => {
        try {
            const result = await apiGet('/ajax/pre_check_two_step_pass');
            onSuccess();
        } catch (err) {
            onError();
        }
    }

    return {checkPassword}
}